export default "__VITE_ASSET__DOjQkxP1__"